import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from 'react';
import './index.css';
import axios from 'axios';

// ColdTrafficLP1 is the main landing page — keep eager so it loads instantly
import ColdTrafficLP1 from './pages/ColdTrafficLP1';

// All other routes are lazy-loaded so their code only downloads when visited
const FunnelLP = lazy(() => import('./pages/FunnelLP'));
const WaitlistConfirmation = lazy(() => import('./pages/Waitlist'));
const InvoicePage = lazy(() => import('./pages/CreateInvoice'));
const Call = lazy(() => import('./pages/Call'));
const DQ = lazy(() => import('./pages/DQ'));
const MQL = lazy(() => import('./pages/MQL'));
const Chat2App = lazy(() => import('./pages/Chat2App'));
const Loom = lazy(() => import('./pages/Loom'));
const VSLV2 = lazy(() => import('./pages/VSLV2'));
const VSLV3 = lazy(() => import('./pages/VSLV3'));
const SplitTestRouter = lazy(() => import('./pages/SplitTestRouter'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const PreviewPage = lazy(() => import('./pages/PreviewPage'));
// Mid-market orchestration lead-magnet funnel (new offer, own pixel)
const SubstrateLP = lazy(() => import('./pages/SubstrateLP'));
const SubstrateThankYou = lazy(() => import('./pages/SubstrateThankYou'));
// Google Search variant: strategy-session-first (no lead magnet gate)
const AITransformationLP = lazy(() => import('./pages/AITransformationLP'));
// Meta instant-form end pages: qualified (video + Calendly) and booted (video only)
const LFVideo = lazy(() => import('./pages/LFVideo'));
// Chicago event LP: embeds the Luma RSVP for "The Operators' Table"
const OperatorsTable = lazy(() => import('./pages/OperatorsTable'));
// "Vibecoded" call funnel: App-Only Lander, no VSL
const VibecodedAOL = lazy(() => import('./pages/VibecodedAOL'));

axios.defaults.baseURL = process.env.REACT_APP_DEV_API_BASE_URL;

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={null}>
          <Routes>
            <Route index path='/' element={<ColdTrafficLP1/>}/>
            <Route path='/free-training' element={<SplitTestRouter/>}/>
            <Route path='/admin' element={<AdminPage/>}/>
            <Route path='/preview' element={<PreviewPage/>}/>
            <Route index path='/create-invoice' element={<InvoicePage/>}/>
            <Route path='/waitlist' element={<WaitlistConfirmation/>}/>
            <Route path='/call' element={<Call/>}/>
            <Route path='/dq' element={<DQ/>}/>
            <Route path='/mql' element={<MQL/>}/>
            <Route path='/booked' element={<Loom/>}/>
            <Route path='/build' element={<Chat2App/>}/>
            <Route path='/vsl-v2' element={<VSLV2/>}/>
            <Route path='/vsl-v3' element={<VSLV3/>}/>
            <Route path='/orchestration' element={<SubstrateLP/>}/>
            <Route path='/orchestration/playbook' element={<SubstrateThankYou/>}/>
            <Route path='/ai-transformation' element={<AITransformationLP/>}/>
            <Route path='/lf-video' element={<LFVideo/>}/>
            <Route path='/lf-video-dq' element={<LFVideo dq/>}/>
            <Route path='/operators-table' element={<OperatorsTable/>}/>
            <Route path='/vibecoded-aol' element={<VibecodedAOL/>}/>
            <Route path='*' element={<ColdTrafficLP1/>}/>
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;